import type { User } from '@/types/user';

/**
 * Whether the member already has the contact info the Member Contact form
 * collects, so the experiment step can be skipped (and not re-prompted on a cold
 * resolve). Address is split across the two objects — state/ZIP/phone on the
 * User, street/city on the customer profile (mirrors VidaReactNative). We treat
 * the member as "complete" only when the required pieces are all present; the
 * apartment line is optional and intentionally not required here.
 */
export function isMemberContactComplete(user: User | undefined): boolean {
  if (!user) return false;
  const profile = user.customerProfile;
  return Boolean(
    user.phone && user.state && user.zipCode && profile?.addressFirstLine && profile?.addressCity
  );
}
